import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import Notifications from "vue-notification";
import "./registerServiceWorker";
import VueApexCharts from "vue-apexcharts";
import { Network } from "vue-vis-network";

Vue.use(VueApexCharts);
Vue.component("network", Network);
Vue.use(Notifications);
window.axios = axios;

// https://aroo30.co/api
//

Vue.prototype.$apiAddress =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000/api"
    : "https://aroo30.co/api";

Vue.prototype.$baseAddress =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000/"
    : "https://aroo30.co/";

console.log(Vue.prototype.$apiAddress);
Vue.prototype.$isAppInstalled = false;
Vue.prototype.$userData = [];
Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
